module.exports = __webpack_public_path__ + "img/headerimg.37c3ea6b.png";